import { render, staticRenderFns } from "./EngineChangelog.vue?vue&type=template&id=c330f04e&scoped=true"
import script from "./EngineChangelog.vue?vue&type=script&lang=js"
export * from "./EngineChangelog.vue?vue&type=script&lang=js"
import style0 from "./EngineChangelog.vue?vue&type=style&index=0&id=c330f04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330f04e",
  null
  
)

export default component.exports